/**
 *
 * SearchType
 *
 * 0: unknown
 * 1: contract
 * 2: externally owned account
 * 3: block
 * 4: transaction
 * 5: token
 * */

// NOTE: 현재 1, 2, 5는 전부 account 페이지에 존재
export const SearchEntity = {
  0: 'unknown',
  1: 'account',
  2: 'account',
  3: 'block',
  4: 'tx',
  5: 'account',
}

export type SearchRes = {
  searchType: keyof typeof SearchEntity
}
